import { gql } from '@apollo/client';

//returns an address
export const PERSON_ADDRESS_HISTORY = gql`
  query personAddressHistory($personId: ID!, $originatorId: ID!){
    personAddressHistory(personId: $personId, originatorId: $originatorId) {
      id
      name
    }
  }
`;